module.exports = new __parcel__URL__("AudioBriefingErrorIllustrationDark.d6496342.svg").toString();